import React, { useState } from "react";
import '../Assets/css/dashboard.css';
import RaiseTicket from "./raiseTicket";
import HomeBG from '../Assets/img/HomeBG.jpg';
import RTimg1 from '../Assets/img/RTimg1.png';
import RTimg2 from '../Assets/img/RTimg2.png';
import RTimg3 from '../Assets/img/RTimg3.png';
import RTimg4 from '../Assets/img/RTimg4.png';
import Xceed from '../Assets/img/Xceed.png';
import Reach from '../Assets/img/Reach.png';
import Attendance from '../Assets/img/Attedance.png';

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Modal from '@mui/material/Modal';

function Home() {

    const [raiseTicketOpen, setRaiseTicketOpen] = useState(false);
    const [deparment, setDepartment] = useState({});

    const handleRTopen = () => setRaiseTicketOpen(true);
    const handleRTclose = () => { setRaiseTicketOpen(false); }

    return (
        <div className="HomePageParent"
            style={{
                backgroundImage: `url(${HomeBG})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            }}
        >
            <div className="HomePageSubSect1">
                <div className="HomePageSubSectForWidth">
                    <div className="AdverAnnounceParentDiv">
                        <div className="AdvertisementParent2">
                            <Carousel className="AdvertisementSub"
                                showThumbs={false}
                                showStatus={false}
                                infiniteLoop={true}
                                autoPlay={true}
                                interval={3000}
                                stopOnHover={true}
                                showArrows={false}
                                swipeable={true}
                                dynamicHeight={false}
                            >
                                <div
                                    className="CarouselSlide"
                                    onClick={() => window.open("https://smartfm.ae/Product/Reach.html", "_blank")}
                                >
                                    <img src={Reach} alt="Reach" className="SlideImageStyle" />
                                </div>

                                <div
                                    className="CarouselSlide"
                                    onClick={() => window.open('https://smartfm.ae/Product/Xceed.html', "_blank")}
                                >
                                    <img src={Xceed} alt="Xceed" className="SlideImageStyle2" />
                                </div>

                                <div
                                    className="CarouselSlide"
                                    onClick={() => window.open("https://smartfm.ae/Product/selfserviceattendance.html", "_blank")}
                                >
                                    <img src={Attendance} alt="Attendance" className="SlideImageStyle" />
                                </div>
                            </Carousel>
                        </div>
                    </div>

                    <div className="RaiseTicketParent">
                        <span className="RaiseTicketText">Create a Ticket</span>
                        <div className="RaiseTicketCardsParent">
                            <div className="RaiseTicketCardSub">
                                <div className="RaisedAticketCardDiv2">
                                    <div className="RATimageSec">
                                        <img src={RTimg1} alt="Support" className="RTimgStyle" />
                                    </div>
                                </div>
                                <div className="RaisedAticketCardDiv1">
                                    <span className="RaisedAticketCardName">Support</span>
                                    <div className="RTclickDiv" onClick={() => { handleRTopen(); setDepartment({ departmentIDPK: 1, department: 'Support' }) }}>Click Here</div>
                                </div>

                            </div>

                            <div className="RaiseTicketCardSub">
                                <div className="RaisedAticketCardDiv2">
                                    <div className="RATimageSec">
                                        <img src={RTimg2} alt="Sales" className="RTimgStyle" />
                                    </div>
                                </div>
                                <div className="RaisedAticketCardDiv1">
                                    <span className="RaisedAticketCardName">Sales</span>
                                    <div className="RTclickDiv" onClick={() => { handleRTopen(); setDepartment({ departmentIDPK: 2, department: 'Sales' }) }}>Click Here</div>
                                </div>
                            </div>

                            <div className="RaiseTicketCardSub">
                                <div className="RaisedAticketCardDiv2">
                                    <div className="RATimageSec">
                                        <img src={RTimg3} alt="Billing" className="RTimgStyle" />
                                    </div>
                                </div>
                                <div className="RaisedAticketCardDiv1">
                                    <span className="RaisedAticketCardName">Billing</span>
                                    <div className="RTclickDiv" onClick={() => { handleRTopen(); setDepartment({ departmentIDPK: 3, department: 'Billing' }) }}>Click Here</div>
                                </div>
                            </div>

                            <div className="RaiseTicketCardSub">
                                <div className="RaisedAticketCardDiv2">
                                    <div className="RATimageSec">
                                        <img src={RTimg4} alt="Help Documents" className="RTimgStyle1" />
                                    </div>
                                </div>
                                <div className="RaisedAticketCardDiv1">
                                    <span className="RaisedAticketCardName">Help Documents</span>
                                    <a className="RTclickDiv" href="https://help.smartfm.cloud/login" target="_blank">Click Here</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="RaiseTicketParent" style={{ display: "none" }}>
                        {/* <span className="RaiseTicketText">Help Documents</span> */}
                        <div className="RaiseTicketCardsParent">
                            <div className="RaiseTicketCardSub">
                                <div className="RaisedAticketCardDiv2">
                                    <div className="RATimageSec">
                                        <img src={RTimg4} alt="Help Documents" className="RTimgStyle1" />
                                    </div>
                                </div>
                                <div className="RaisedAticketCardDiv1">
                                    <span className="RaisedAticketCardName">Help Documents</span>
                                    <a className="RTclickDiv" href="https://help.smartfm.cloud/login" target="_blank">Click Here</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <span className="OurTeamMsg">Our support team is available to assist you from Monday to Saturday, 8:00 AM to 5:00 PM.</span>

            </div>

            <Modal
                open={raiseTicketOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="ModalParentStyle"
            >
                <div className="RTmodalParentDiv">
                    <RaiseTicket handleRTclose={handleRTclose} fromHome={true} departmentIDPK={deparment.departmentIDPK} department={deparment.department} />
                </div>
            </Modal>
        </div>
    )
}

export default Home;